import actions from "./actions";

const initState = {
    types: [],
    readAllActionState: null,
    dynamicState: null,
    config: {
        type: "",
        items: [],
    },
    isVisible: false,
};

export default function appReducer(state = initState, action = { }) {
    switch (action.type) {
        case actions.READ_ALL_ACTION_REQUEST:
            return {
                ...state,
                readAllActionState: 'request',
            };
        case actions.READ_ALL_ACTION_SUCCESS:
            return {
                ...state,
                config: action.config,
                readAllActionState: 'success',
            };
        case actions.READ_ALL_ACTION_ERROR:
            return {
                ...state,
                readAllActionState: 'error',
            };
        case actions.DYNAMIC_ACTION_REQUEST:
            return {
                ...state,
                dynamicState: 'request',
            };
        case actions.DYNAMIC_ACTION_SUCCESS:
            return {
                ...state,
                response: action.responseMessage,
                title: action.config.title,
                isVisible: true,
                dynamicState: 'success',
            };
        case actions.DYNAMIC_ACTION_ERROR:
            return {
                ...state,
                response: action.responseMessage,
                title: action.config.title,
                isVisible: true,
                dynamicState: 'error',
            };
        case actions.HideModel_Action:
            return {
                ...state,
                isVisible: false,
                responseMessage: '',
                dynamicState: null,
            };
        default:
            return state;
    }
}
